import { render, staticRenderFns } from "./cardFollow.vue?vue&type=template&id=83dfe00e&scoped=true&"
import script from "./cardFollow.vue?vue&type=script&lang=js&"
export * from "./cardFollow.vue?vue&type=script&lang=js&"
import style0 from "./cardFollow.vue?vue&type=style&index=0&id=83dfe00e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83dfe00e",
  null
  
)

export default component.exports